import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AdditionalPACData } from '../models/additional-pac-data.model';

/**
 * Drives the "payment still under processing" countdown popup (CR-2026-30 Part B). Populated
 * from every place a blocked response can surface: the CyberSource return redirect
 * (court-payment.component.ts), the /payment/initiate response (credit-debit-card.component.ts),
 * the Cheque/PayNow/deposit endpoints (payment-method.component.ts), and a plain PAC-details
 * refetch (pac.service.ts) - all carry the same pacNumber/retryAfterSeconds contract from
 * payment-portal-be. pacNumber lets AppComponent poll for early clearance so it can refresh
 * in place instead of waiting out the full TTL.
 *
 * blockResolved$ is the deliberate opposite of a hard page reload: a full reload on the
 * CyberSource-redirect page re-parses the still-present messageCode=payment_processing query
 * param and re-triggers the popup (and causes a visible flash besides). Instead, AppComponent
 * fetches fresh PAC data once the block clears and broadcasts it here; the currently active page
 * component (court-payment / court-deposit-details) applies it directly via its own
 * assignPacDetails, with no navigation involved.
 */
@Injectable({ providedIn: 'root' })
export class PaymentBlockService {
  public showPaymentBlockedModal$ = new Subject<{ pacNumber: string; retryAfterSeconds: number }>();
  public blockResolved$ = new Subject<AdditionalPACData>();

  notifyBlocked(pacNumber: string | undefined | null, retryAfterSeconds: number): void {
    if (pacNumber && retryAfterSeconds > 0) {
      this.showPaymentBlockedModal$.next({ pacNumber, retryAfterSeconds });
    }
  }

  notifyResolved(data: AdditionalPACData): void {
    this.blockResolved$.next(data);
  }
}
